<template lang="pug">
.chip(:id='id', :style='{ backgroundColor, borderColor, color, borderRadius, width }')
    .chip-icon.mdi(
        v-if='icon',
        :style='{ color: color ? color : "var(--primary-white)", cursor: $listeners.iconAction ? "pointer" : "", order: iconPosition === "right" ? 1 : 0  }',
        :class='icon',
        @click='handleIconClick'
    )
    label.chip-label(v-if='label', :style='{ color }') {{ label }}
</template>

<script>
export default {
    name: 'ChipComponent',

    data: () => ({}),

    props: {
        id: {
            type: String,
            default: () => `chip-${Math.ceil(Math.random() * 10000)}`,
        },

        label: {
            type: String,
            default: '',
        },

        icon: {
            type: String,
            default: '',
        },

        iconPosition: {
            type: String,
            default: '',
        },

        color: {
            type: String,
            default: null,
        },

        backgroundColor: {
            type: String,
            default: null,
        },

        borderColor: {
            type: String,
            default: null,
        },

        borderRadius: {
            type: String,
            default: '15px',
        },

        width: {
            type: String,
            default: ''
        }
    },
    methods: {
        handleIconClick() {
            this.$emit('iconAction');
        },
    },
};
</script>

<style>
.chip {
    width: fit-content;
    padding: 2px 5px 2px 5px;

    display: flex !important;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;

    color: var(--primary-white);
    background-color: var(--primary-green);
}

.chip-icon {
    color: var(--primary-white);
}

.chip-label {
    color: var(--primary-white);
}
</style>
